/* Original-brand navigation with scroll contrast, native menus and instance cleanup. */
(() => {
  'use strict';
  if (window.MuteMeHeader) { window.MuteMeHeader.init(document); return; }
  const instances = new Map();

  function initialize(root = document) {
    const headers = [...root.querySelectorAll('[data-mm-header]')];
    if (root.matches?.('[data-mm-header]')) headers.unshift(root);
    headers.forEach(header => {
      if (instances.has(header)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const toggle = header.querySelector('[data-mm-search-toggle]');
      const panel = header.querySelector('[data-mm-search-panel]');
      const mobile = header.querySelector('.mm-mobile-nav');
      const mobileToggle = mobile?.querySelector('summary');
      const desktopMenus = [...header.querySelectorAll('.mm-nav details')];
      const cartLink = header.querySelector('.mm-header__cart');
      const cartCount = header.querySelector('.header-cart-count');
      const wrapper = header.closest('.shopify-section');
      let observer;
      let scrollFrame;
      if (!toggle || !panel || !mobile) return;
      header.dataset.ready = 'true';
      wrapper?.classList.toggle('mm-header-sticky', header.classList.contains('mm-header--sticky'));

      const updateTone = () => {
        scrollFrame = null;
        const scrolled = (window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0) > 40;
        header.dataset.mmHeaderScrolled = String(scrolled);
        header.dataset.mmHeaderTone = scrolled ? 'light' : 'dark';
      };
      const scheduleTone = () => {
        if (scrollFrame == null) scrollFrame = requestAnimationFrame(updateTone);
      };
      updateTone();
      window.addEventListener('scroll', scheduleTone, { passive: true, signal: controller.signal });
      window.addEventListener('pageshow', updateTone, options);

      if (cartLink && cartCount) {
        const updateLabel = () => cartLink.setAttribute('aria-label', `Cart, ${cartCount.textContent.trim()} items`);
        observer = new MutationObserver(updateLabel);
        observer.observe(cartCount, { childList: true, characterData: true, subtree: true });
        updateLabel();
      }
      const closeSearch = () => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
      const closeDesktop = except => desktopMenus.forEach(menu => { if (menu !== except) menu.open = false; });
      toggle.addEventListener('click', () => {
        const opening = panel.hidden;
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', String(opening));
        if (opening) {
          mobile.open = false;
          closeDesktop();
          panel.querySelector('input')?.focus();
        }
      }, options);
      mobile.addEventListener('toggle', () => {
        mobileToggle.setAttribute('aria-label', mobile.open ? 'Close navigation' : 'Open navigation');
        if (mobile.open) { closeSearch(); closeDesktop(); }
      }, options);
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (!panel.hidden) {
          closeSearch(); toggle.focus(); event.preventDefault(); return;
        }
        const menu = event.target.closest('details[open]');
        if (menu && header.contains(menu)) {
          menu.open = false; menu.querySelector('summary')?.focus(); event.preventDefault();
        } else if (mobile.open) {
          mobile.open = false; mobileToggle.focus(); event.preventDefault();
        }
      }, options);
      desktopMenus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          if (menu.open) { closeDesktop(menu); closeSearch(); mobile.open = false; }
        }, options);
        menu.addEventListener('focusout', event => {
          if (!menu.contains(event.relatedTarget)) menu.open = false;
        }, options);
      });
      document.addEventListener('click', event => {
        desktopMenus.forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
        if (!header.contains(event.target)) { closeSearch(); mobile.open = false; }
      }, options);
      instances.set(header, () => {
        controller.abort();
        observer?.disconnect();
        if (scrollFrame != null) cancelAnimationFrame(scrollFrame);
        delete header.dataset.ready;
      });
    });
  }
  const destroy = root => {
    for (const [header, cleanup] of instances) {
      if (root === header || root.contains(header)) { cleanup(); instances.delete(header); }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  window.MuteMeHeader = { init: initialize, destroy };
})();
